import ventilations from './ventilations'

class GlassOrder {
    constructor(formData, corrections) {
        // Parameters
        const { position, width, height, number, type, glass, ventilation, commentsGlass } = formData


        let height_correction = 0;
        let width_correction = 0;

        // Just glass
        if(type === '1') {
            height_correction = corrections.glass_height_correction;
            width_correction = corrections.glass_width_correction;
        }

        // Correction for window
        if(type === '2') {
            width_correction =  corrections.glass_width_correction_window;
            height_correction = corrections.glass_height_correction_window;
        }

        // If ventilation present
        if(ventilation) {
            height_correction += ventilations.find(ventilationType => ventilationType.name === ventilation).height_correction;
        }

        this.glass = glass;
        this.number = number;
        this.height = height - height_correction;
        this.width = width - width_correction;
        this.description = "HRGas " + glass + " " + this.width + " x " + this.height;

        if(position)
            this.description += " Pos: " + position;

        if(commentsGlass)
            this.description += "   Opmerking: " + commentsGlass;
    }
}

export default GlassOrder


// WEBPACK FOOTER //
// ./src/data/GlassOrder.js